import React from 'react'
import { connect } from 'react-redux'
import { ORDER_FILTER_STATUS } from '@/constants/filter-type';
import Dropdown from '@/components/Dropdown/Dropdown';
import classnames from 'classnames'
import { formatFunctions, utilsFunction } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import '../../assets/styles/components/order/order-history.scss';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { DATE_CONSTANT } from '@/constants/app';
import { mobileSubLayoutAction } from '@/actions/app/mobileSubLayout.action';
import DatePickerCustom from '@/components/DatePicker/DatePickerCustom';
import TabHeaderMobile from '@/components/TabHeader/TabHeader.mobile';
import { ORDER_FILTER_STATUS_GROUP_MOBILE } from '@/constants/filter-type';
import orderStatusData from '@/assets/data/order_status.json';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import NoRow from '@/components/DataTable/CustomNoRow';

const timeOptions = [
  {
    label: 'Last Week',
    value: 'last_week',
    valueObject: {
      quantity: 7,
      unit: DATE_CONSTANT.DAYS
    }
  },
  {
    label: 'Last Month',
    value: 'last_month',
    valueObject: {
      quantity: 1,
      unit: DATE_CONSTANT.MONTH
    }
  },
  {
    label: 'Last Three Month',
    value: 'last_three_month',
    valueObject: {
      quantity: 3,
      unit: DATE_CONSTANT.MONTH
    }
  },
  {
    label: 'Last Six Month',
    value: 'last_six_month',
    valueObject: {
      quantity: 6,
      unit: DATE_CONSTANT.MONTH
    }
  }
]

const ORDER_HISTORY_TABLE = 4;

class OrderHistoryMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      searchParams: {},
      load: false
    }
  }

  render() {
    const { language } = this.props;
    const { orders, load } = this.state;
    return (
      <div className='order-history-mobile-container'>
        {this.renderOrderFilterDropdown()}
        <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
        {orders.length > 0
          ? <div className="order-list">
              {orders.map((order,index) => 
                  <div className="order-item" key={index}>
                  <header onClick={() => this.handleViewDetail(order)}>
                    <span>{`${language.common_order_id} ${order.orderGroupID} >`}</span>
                    <span className={classnames(order.bs === 'B' ? 'buy-color' : 'sell-color')}>
                      {language[order.bs === 'B' ? 'common_buy' : 'common_sell']}
                    </span>
                  </header>
                  <section className="info-list">
                    <div className='info-item order-id'>
                      <span>{`${order.marketID}.${order.instrumentID}`}</span>
                      <span>{language.lang === 'en_US'? order.instrumentName : order.instrumentChineseName}</span>
                    </div>
                    <div className='info-item order-type'>
                      {order.orderType === '-' ? '-' : language[`order_type_${order.orderType.toLowerCase()}`]}
                    </div>
                    <div className="info-item">
                      <label>{language.common_price}</label>
                      <span>{formatFunctions.dataFormat(order.price, dataType.CURRENCY)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_market}</label>
                      <span>{order.marketID}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_filled_qty}</label>
                      <span>{formatFunctions.dataFormat(order.filledQty, dataType.NUMBER)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_quantity}</label>
                      <span>{formatFunctions.dataFormat(order.qty, dataType.NUMBER)}</span>
                    </div>
                    <div className="info-item">
                      <label>{language.common_avg_price}</label>
                      <span>{formatFunctions.dataFormat(order.avgPrice, dataType.CURRENCY)}</span>
                    </div>
                    <div className='info-item'>
                      <label>{language.common_status}</label>
                      <span>{language[`order_status_${order.status.toLowerCase()}`]}</span>
                    </div>
                  </section>
                  <section className="info-createTime">
                    <label>{language.common_create_time}:</label>
                    <span>{formatFunctions.dataFormat(order.inputTime, dataType.LONG_DATE)}</span>
                  </section>
                </div>
              )}
          </div>
          : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' , width :'100%'}} />
        }
      </div>
    )
  }
  
  handleViewDetail = (order) => {
    mobileSubLayoutAction.openOrderJournalDetail(order)
  }

  onChangeMarket(market) {
    const selectMarket = market.value;
    this.setState({
      searchParams: Object.assign({}, this.state.searchParams, { selectMarket })
    },() => {
      this.getData();
    })
  }

  renderOrderFilterDropdown() {
    const { language, markets } = this.props;
    const { maximumDate } = this.state;
    const filterOptions = ORDER_FILTER_STATUS.reduce((acc, opt) => {
      acc.push({ label: language[opt.label], value: opt.value })
      return acc;
    }, [])
    let statusFilterOption = JSON.parse(JSON.stringify(ORDER_FILTER_STATUS_GROUP_MOBILE));
    statusFilterOption.map(item => {
      item.label = language[item.label]
    })
    return (
      <div className="filter-dropdown">
        <div className='filter-date'>
          <TabHeaderMobile
            innerRef={e => this.tabHeaderOrderRefMobile = e}
            dateRangePicker={true}
            maximumDate={maximumDate}
            onChangeDatePicker={this.handleChangeDatePicker}
            //  orderFilterDropdown={true}
            //  orderFilterRadio={false}
            />
        </div>
        <div className='filter-other'>
          <Dropdown options={markets} style={{ height: 'unset' }}
            selectedOptions={[markets[0]]}
            onChange={(mrk) => this.onChangeMarket(mrk[0])}
            />
          <Dropdown options={statusFilterOption}
            style={{ height: 'unset' }}
            selectedOptions={[statusFilterOption[0]]}
            onChange={(opt) => this.handleFilterByStatus(opt[0])} />
        </div>
      </div>
    )
  }

  handleFilterByStatus = (val) => {
    let status = '';
    if(val.value !== 'all'){
      const statusList = Object.keys(orderStatusData[val.value]);
      status = statusList.join(","); 
    }
    this.setState({ searchParams: Object.assign({}, this.state.searchParams, { status }) }, () => this.getData())
  }

  handleFilterByDate = (val) => {
    const date = val.valueObject;
    const startDate = utilsFunction.modifyDateFromNow(DATE_CONSTANT.SUBTRACT, date.quantity, date.unit);
    this.setState({ searchParams: Object.assign({}, this.state.searchParams, { startDate }) }, () => this.getData())
  }

  handleChangeDatePicker = (date) => {
    const startDate = this.convertDateObjectToString(date.from);
    const endDate = this.convertDateObjectToString(date.to);
    const { searchParams } = this.state;
    if (startDate !== searchParams.startDate || endDate !== searchParams.endDate) {
      this.setState({
        searchParams: Object.assign({}, searchParams,
          {
            startDate,
            endDate
          })
      },() => {
        this.getData();
      })
    }
  }

  getData() {
    const { currentTradingAccount } = this.props
    const { searchParams } = this.state;
    this.setState({load: true})
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: searchParams.status,
        [PARAMS.START_DATE]: searchParams.startDate,
        [PARAMS.END_DATE]: searchParams.endDate,
        [PARAMS.MARKET_ID]: searchParams.selectMarket,
      }
      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ orders: res.result.orderInfoList });
          }
        }
        this.setState({load: false})
      })
    }
  }

  setStartEndDate () {
    const maximumDate = this.getMaximumDate();
    this.setState({
      orderTableTab: ORDER_HISTORY_TABLE,
      searchParams: {
        status: '',
        startDate: this.convertDateObjectToString(maximumDate),
        endDate: this.convertDateObjectToString(maximumDate),
        selectMarket: ''
      }
    }, () => {
      // this.tabHeaderOrderRefMobile.setDatePickerValue(maximumDate);
      this.getData();
    })
  }

  convertDateObjectToString(date) {
    return `${date.year}-${date.month}-${date.day}`
  }

  getMaximumDate() {
    let date = new Date();
    date.setDate(date.getDate() - 1); // get yesterday
    const maximumDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    }
    this.setState({ maximumDate })
    return maximumDate;
  }

  componentDidMount() {
    // const date = timeOptions[0].valueObject;
    // const startDate = utilsFunction.modifyDateFromNow(DATE_CONSTANT.SUBTRACT, date.quantity, date.unit);
    // let endDate = utilsFunction.modifyDateFromNow(DATE_CONSTANT.SUBTRACT, 0, DATE_CONSTANT.DAYS);
    // this.setState({
    //   searchParams: {
    //     status: '',
    //     startDate,
    //     endDate
    //   }
    // }, () => this.getData())
    // this.getData();
    this.setStartEndDate();
  }

  componentDidUpdate(prevProps) {
    const { language } = this.props
  	if (language && prevProps.language !== language) {
    	this.setStartEndDate();
  	}
  }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets]
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c))
  })
)(OrderHistoryMobile)
